import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import   Film  from "./Film";

const apiUrl = 'https://swapi.py4e.com/api/people';



export default function CharacterPage() {
    const { id } = useParams();
    const [characterData, setCharacterData] = useState({});

    useEffect(() => {
        async function fetchSingleCharacter() {
            try {
                const res = await fetch(`${apiUrl}/${id}/?format=json`);
                if (!res.ok) {
                    console.error('Failed to fetch character', res.status);
                    return;
                }
                const data = await res.json();
                setCharacterData(data);
            } catch (err) {
                console.error('Error fetching character:', err);
            }
        }
        fetchSingleCharacter()
    }, [id])

    return <>
        <div className="characterPage">
            <h2> {characterData.name}</h2>
            <div className="charCaracteristics">
                <div className="charContainer"> <p>Height: {characterData.height}</p> </div>
                <div className="charContainer"> <p>Eye color: {characterData.eye_color}</p> </div>
                <div className="charContainer"> <p>Birth Date: {characterData.birth_year}</p> </div>
                <div className="charContainer"> <p>Hair color: {characterData.hair_color}</p> </div>
            </div>
            <div className="charCaracteristics">
                <p> {characterData.films && characterData.films.length} films</p>
            </div>
                <div className="films">
                    <div>
                        {characterData.films && characterData.films.map(film => <Film url = {film}/>)}
                    </div>
                </div>
            </div>
            <div className="charCaracteristics">
                <Link to="/" className="goBackHome">Go Back Home...</Link>
            </div>
    </>
}
